import { gql } from '@apollo/client';

export const CREATE_STRIPE_PORTAL_SESSION = gql`
  mutation CreatePortalSession {
    createPortalSession {
      url
    }
  }
`;
